import { z } from 'zod';

export const GetExternalDocumentPacketBlockConfigSchema = z.object({
  externalDocumentPacketId: z.string().optional(),
});

export type GetExternalDocumentPacketBlockConfig = z.infer<
  typeof GetExternalDocumentPacketBlockConfigSchema
>;
